import api from "./client";

// Web push: own devices and per-event switches. Backend: routes/push.py.
export const getPushConfig = () => api.get("/push/config");
export const subscribePush = (subscription) =>
  api.post("/push/subscribe", { subscription, user_agent: navigator.userAgent || "" });
export const unsubscribePush = (endpoint) => api.post("/push/unsubscribe", { endpoint });
export const savePushPreferences = (events) => api.put("/push/preferences", { events });
export const sendTestPush = () => api.post("/push/test");
